import React from 'react'
import Checkbox from 'react-toolbox/lib/checkbox'
import { Flex, Box } from 'reflexbox'

import theme from './FulcrumCheckbox.scss'

export default class FulcrumCheckbox extends React.Component {
  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.update === false) {
      return false
    }
    return true
  }
  render() {
    let props = {...this.props }
    delete props['update']
    return (
      <Checkbox
        checked={this.props.checked}
        className={theme.themedFulcrumCheckbox}
        theme={theme}
        onChange={this.props.onChange}
        {...props}
      />
    )
  }
}
